/** Browser-local user token — created on first visit, persists across reloads.
 *  This is intentionally NOT auth — just a stable per-browser identifier so the
 *  Library API can scope each user's songs without needing a login.
 *
 *  iter-95 — Reads localStorage on every call (no module-level cache) so the
 *  token can be swapped to the authenticated user_id on login without the
 *  app needing a hard reload. localStorage access is microsecond-fast, so the
 *  perf cost of dropping the cache is negligible.
 */

const STORAGE_KEY = "elpm-user-token";

function makeUuid() {
  try {
    if (typeof crypto?.randomUUID === "function") return crypto.randomUUID();
  } catch (e) { void e; }
  // Fallback for older browsers / sandboxes — Math.random is fine, this isn't security.
  return "elpm-" + Math.random().toString(36).slice(2, 12) + "-" + Date.now().toString(36);
}

export function getUserToken() {
  try {
    let t = localStorage.getItem(STORAGE_KEY);
    if (!t || t.length < 8) {
      t = makeUuid();
      localStorage.setItem(STORAGE_KEY, t);
    }
    return t;
  } catch (e) {
    // localStorage blocked (private mode, etc.) — fall back to a per-page UUID.
    void e;
    if (!globalThis.__elpmInMemoryToken) globalThis.__elpmInMemoryToken = makeUuid();
    return globalThis.__elpmInMemoryToken;
  }
}

/** Force the next getUserToken() call to read fresh from localStorage.
 *  Kept as a noop (legacy) — getUserToken now always reads localStorage. */
export function resetUserTokenCache() { /* noop */ }

/** Convenience: returns `{ "X-User-Token": "..." }` — spread into axios
 *  `headers` blocks so every place we send the token does it consistently. */
export function userTokenHeader() {
  return { "X-User-Token": getUserToken() };
}
